/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mPage.vue?vue&type=template&id=0436f93e&scoped=true"
import script from "./mPage.vue?vue&type=script&lang=js"
export * from "./mPage.vue?vue&type=script&lang=js"
import style0 from "./mPage.vue?vue&type=style&index=0&id=0436f93e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0436f93e",
  null
  
)

export default component.exports